import React from "react"
import Link from "../../adapters/Link"
export function SmartLink({ item, className, children, onClick }) {
  const content = children ?? item.label
  if (item.to) {
    return (
      <Link href={item.to} className={className} onClick={onClick}>
        {content}
      </Link>
    )
  }
  return (
    <a href={item.href} className={className} onClick={onClick}>
      {content}
    </a>
  )
}
